export { default } from './Auth'
export * from './Auth'



// WEBPACK FOOTER //
// ./src/containers/Auth/index.ts